export default "__VITE_ASSET__BXLT$csq__"